module.exports = __webpack_public_path__ + "2bdf664673d660fca1d31742615cbe69.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/map-bg-with-location.svg
 ** module id = 1554
 ** module chunks = 0
 **/